<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 33 35"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(16.500000, 17.500000) scale(-1, 1) translate(-16.500000, -17.500000) "
    >
      <path
        d="M16.4998964,0 C4.32110064,0 0,9.37308125 0,19.0892678 C0,19.5103934 0.359757143,19.8515625 0.803421175,19.8515625 L1.48859277,19.8512961 C1.86887018,19.8511483 2.19690846,19.5978565 2.27447313,19.2444857 C2.53269985,18.0680508 3.63115725,17.2105527 4.91415981,17.2105527 C6.19716238,17.2105527 7.29561978,18.0680508 7.55384649,19.2444857 C7.63143635,19.5979712 7.95965483,19.8512962 8.34005573,19.8512962 L9.21775077,19.8512962 C9.59815166,19.8512962 9.92637014,19.5979712 10.00396,19.2444857 C10.2621867,18.0680508 11.3606441,17.2105527 12.6436467,17.2105527 C13.9266492,17.2105527 15.0251066,18.0680508 15.2833334,19.2444857 C15.3609232,19.5979712 15.6891417,19.8512962 16.0695426,19.8512962 L16.9302497,19.8512962 C17.3106506,19.8512962 17.6388691,19.5979712 17.716459,19.2444857 C17.9746857,18.0680508 19.0731431,17.2105527 20.3561457,17.2105527 C21.6391482,17.2105527 22.7376056,18.0680508 22.9958323,19.2444857 C23.0734222,19.5979712 23.4016407,19.8512962 23.7820416,19.8512962 L24.6597366,19.8512962 C25.0401375,19.8512962 25.368356,19.5979712 25.4459458,19.2444857 C25.7041726,18.0680508 26.80263,17.2105527 28.0856325,17.2105527 C29.3686351,17.2105527 30.4670925,18.0680508 30.7253192,19.2444857 C30.8028839,19.5978565 31.1309222,19.8511483 31.5111996,19.8512961 L32.1963716,19.8515625 C32.6424669,19.8515625 33.0032237,19.5067845 33,19.0833639 L32.9965299,18.6864379 C32.8408683,9.19698056 28.6786922,0 16.4998964,0 Z"
        id="Path"
        :fill="fill"
      ></path>
      <path
        d="M16.5249147,21.3984375 C17.0905424,21.3984375 17.5523196,21.5193525 17.5797867,22.0781669 L17.5810793,22.1308802 L17.5810793,31.2059411 C17.5810793,31.8191578 18.0781896,32.3162681 18.6914062,32.3162681 C19.2860406,32.3162681 19.7714987,31.8488292 19.8003743,31.2613576 L19.8017332,31.2059411 L19.8017332,31.1090309 C19.8017332,30.5257273 20.2745942,30.3902705 20.8578978,30.3902705 C21.4235256,30.3902705 21.8853028,30.4975032 21.9127699,31.0563176 L21.9140625,31.1090309 L21.9140625,31.2059411 C21.9140625,32.985765 20.4712302,34.4285974 18.6914062,34.4285974 C16.9385494,34.4285974 15.5125496,33.029156 15.4697398,31.2866063 L15.46875,31.2059411 L15.46875,22.1308802 C15.46875,21.5475766 15.941611,21.3984375 16.5249147,21.3984375 Z"
        id="Path-5"
        :fill="fill"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 33,
    },
    height: {
      type: Number,
      default: 35,
    },
    fill: {
      type: String,
      default: "#FF3D37",
    },
  },
};
</script>

<style></style>
